/*
@description - This function converts the string into Sentence Case
@input - String
@ouput - String with sentence casing
*/

import { CoversionFactorCMToUnits, CoversionFactorUnitsToCM } from "../Constant/MeasurementUnitList";

export const capital_letter = (str) => {
  str = str.split(" ");
  for (var i = 0, x = str.length; i < x; i++) {
    str[i] =
      typeof str[i][0] === "string"
        ? str[i][0].toUpperCase() + str[i].substr(1)
        : str[i][0];
  }
  let customerName;
  str.forEach((ele) => {
    if(ele != undefined){
      if (customerName) {
        customerName = customerName + " " + ele;
      } else {
        customerName = ele;
      }
    }
  });
  return customerName.trim();
};

/*
@description - This function returns date in day-shortMonth-fullYear(10 Nov 2022) format
@input - date
@ouput - date in day-shortMonth-fullYear
*/

export const convertDate = (str) => {
  let newDate = new Date(str);
  let day = newDate.getDate();
  let shortMonth = newDate.toLocaleString("default", { month: "short" });
  let year = newDate.getFullYear();
  let fullDate = day + " " + shortMonth + " " + year;
  return fullDate;
};

export function transformPatternData(patterns,jobCard,unitData) {
  const table = [];

  for (let index = 0; index < patterns.partitions.length; index++) {
    const row = patterns.partitions[index];
    const tr = [];
    const deckle_length = jobCard.group.machines[0].units?.effective_deckle_length ? jobCard.group.machines[0].effective_deckle_length * CoversionFactorUnitsToCM[jobCard.group.machines[0].units?.effective_deckle_length] * CoversionFactorCMToUnits[unitData?.units_management?.length.default]: jobCard.group.machines[0].effective_deckle_length * CoversionFactorCMToUnits[unitData?.units_management?.length.default];
    const {
      deadline,
      repeated,
      length,
      trim_loss_width,
      trim_loss_area,
      trim_loss_weight,
      units
    } = row;
    let totalWeight = 0;
    for (let rowindex = 0; rowindex < row.partition.length; rowindex++) {
      const td = row.partition[rowindex];
      totalWeight = totalWeight + td.weight;
      tr.push({
        ...td,
        percentWidth: (td.breadth / deckle_length) * 100,
      });
    }
    // for (let key in row) {
    //   const td = row[key];
    //   if (key.includes("partition")) {
    //     tr.push({
    //       ...td,
    //       percentWidth: (td.breadth / deckle_length) * 100,
    //     });
    //   }
    // }
    table.push({
      tr,
      row_meta: {
        percentTrimLossWidth: (trim_loss_width / deckle_length) * 100,
        deadline,
        repeated,
        length,
        deckle_length,
        trim_loss_width,
        trim_loss_area,
        trim_loss_weight,
        totalWeight,
        units
      },
    });
  }
  
  return table;
}

export function transformPatternDuplexData(patterns,jobCard) {
  const table = [];

  for (let index = 0; index < patterns.partitions.length; index++) {
    const row = patterns.partitions[index];
    const tr = [];
    const deckle_length = jobCard.group.machines[0].effective_deckle_length;
    const {
      deadline,
      repeated,
      length,
      total_trim_loss_width,
      left_trim_loss_width,
      right_trim_loss_width,
      trim_loss_area,
      trim_loss_weight,
      left_width,
      right_width,
      left_length,
      right_length,
      left_repeated,
      right_repeated,
      right_order_weight,
      left_order_weight,
      units
    } = row;

    let leftTrim = left_trim_loss_width > 0 ? left_trim_loss_width : 0;
    let rightTrim =  right_trim_loss_width > 0 ? right_trim_loss_width : 0;
    let totalLeftWeight = 0;
    let totalRightWeight = 0;
    let trLeft = [];
    let trRight = [];
    let rightTotalWidth  = 0;
    for (let rowindex = 0; rowindex < row.partition.length; rowindex++) {
      const td = row.partition[rowindex];
      if(td.position === 'left')
      {
        totalLeftWeight = totalLeftWeight + td.weight;
      trLeft.push({
        ...td,
        percentWidth: (td.breadth / (left_width+leftTrim)) * 100,
      });
    }
    else
    {
      totalRightWeight = totalRightWeight + td.weight;
      rightTotalWidth = rightTotalWidth + (td.breadth / (left_width+right_width)) * 100
      trRight.push({
        ...td,
        percentWidth: (td.breadth / (right_width + rightTrim+ leftTrim)) * 100,
      });
    }
    }
    // for (let key in row) {
    //   const td = row[key];
    //   if (key.includes("partition")) {
    //     tr.push({
    //       ...td,
    //       percentWidth: (td.breadth / deckle_length) * 100,
    //     });
    //   }
    // }
    table.push({
      trLeft,
      trRight,
      row_meta: {
        percentTrimLossWidth: (total_trim_loss_width / (left_width+right_width+total_trim_loss_width)) * 100,
        percentRightTrimLossWidth: (rightTrim / (right_width+rightTrim)) * 100,
        percentLeftTrimLossWidth: (leftTrim / (left_width+leftTrim)) * 100,
        deadline,
        repeated,
        length,
        deckle_length,
        total_trim_loss_width,
        trim_loss_area,
        trim_loss_weight,
        totalLeftWeight : left_order_weight,
        totalRightWeight : right_order_weight ? right_order_weight : 0,
        left_width,
        right_width,
        left_length,
        right_length,
        left_repeated,
       right_repeated,
       left_trim_loss_width : leftTrim,
       right_trim_loss_width : rightTrim,
       left_percentage : ((left_width+leftTrim) / (left_width+right_width+ rightTrim+leftTrim)) * 100,
       right_percentage : ((right_width + rightTrim) / (left_width+right_width+ rightTrim+leftTrim)) * 100,
       units
      // rightTotalWidth :  rightTotalWidth + (trim_loss_width / (left_width+right_width)) * 100
      },
    });
  }
  
  return table;
}

export function toFixedValue(num, fixed) {
  var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
  return num.toString().match(re)[0];
}

export function toHandlePOName(poName) {
  // console.log('poName', poName);

  // Strip encoded suffixes (customer + date) after the first separator.
  if (poName == null || poName === "") return poName;
  return String(poName).split("#%#")[0];
}

// function to combine reels with same specifications in production details and job cards
export   function mergeReels(data) {
  const merged = [];
  const visited = new Array(data.length).fill(false);

  for (let i = 0; i < data.length; i++) {
    if (visited[i]) continue;

    let item = data[i];

    const itemOrders = item.orders.filter(o => o.item_type !== "trim_loss" );
// console.log("itemOrders",itemOrders);

    let total_order_width = itemOrders.reduce(
      (a, b) => a + b.reel_width,
      0
    );

    // Clone first occurrence (delivery_date preserved automatically)
    let newItem = {
      ...item,
      orders: [...item.orders]
    };

    visited[i] = true;

    for (let j = i + 1; j < data.length; j++) {
      if (visited[j]) continue;

      let compareItem = data[j];
    //   console.log(compareItem.orders)

      const compareOrders = compareItem.orders.filter(
        o => o.item_type !== "trim_loss"
      );
    //   console.log("compareOrders",compareOrders);

      let total_compare_order_width = compareOrders.reduce(
        (a, b) => a + b.reel_width,
        0
      );

      const ordersSame =
        itemOrders.length === compareOrders.length &&
        itemOrders.every((ele, index) =>
          ele.reel_width === compareOrders[index]?.reel_width &&
          ele.order_type === compareOrders[index]?.order_type
        );
        // console.log(ordersSame,i+1,j+1);

      if (
        total_order_width === total_compare_order_width &&
        item.trim_loss === compareItem.trim_loss &&
        item.reel_od === compareItem.reel_od &&
        item.core_id === compareItem.core_id &&
        ordersSame
      ) {
        // Merge counts
        newItem.count += compareItem.count;
        newItem.actual_count += compareItem.actual_count;
        newItem.cancelled_count += compareItem.cancelled_count;

        visited[j] = true;
      }
    }

    merged.push(newItem);
  }

  return merged;
}

// function to combine sheets with same specifications in production details and job cards
export function mergeCuttingPlans(data) {
  const isEqualNumber = (a, b, tolerance = 0.0001) =>
    Math.abs(Number(a) - Number(b)) < tolerance;

  // Deep copy to avoid mutating original array
  const result = JSON.parse(JSON.stringify(data));

  for (let i = 0; i < result.length; i++) {
    for (let j = i + 1; j < result.length; j++) {

      const item = result[i];
      const compareItem = result[j];

      const patternMatch =
        item.cutting_pattern.length === compareItem.cutting_pattern.length &&
        item.cutting_pattern.every((v, idx) =>
          isEqualNumber(v, compareItem.cutting_pattern[idx])
        );

      if (
        isEqualNumber(item.reel_size, compareItem.reel_size) &&
        isEqualNumber(item.reel_dia, compareItem.reel_dia) &&
        isEqualNumber(item.core_dia, compareItem.core_dia) &&
        isEqualNumber(item.left_edge_trim, compareItem.left_edge_trim) &&
        isEqualNumber(item.right_edge_trim, compareItem.right_edge_trim) &&
        isEqualNumber(item.trim_loss, compareItem.trim_loss) &&
        item.rewinder_code === compareItem.rewinder_code &&
        isEqualNumber(item.length, compareItem.length) &&
        patternMatch
      ) {

        // 🔥 Merge values
        item.no_of_reels += compareItem.no_of_reels;
        item.total_weight += compareItem.total_weight;
        item.total_no_of_sheets += compareItem.total_no_of_sheets;

        // Append cutting_combination_no
        item.cutting_combination_no =
          item.cutting_combination_no +
          "," +
          compareItem.cutting_combination_no;

        // Merge combination_position
        item.combination_position = [
          ...(item.combination_position || []),
          ...(compareItem.combination_position || [])
        ];

        // OPTIONAL: merge partitions
        // item.cutting_partitions = [
        //   ...(item.cutting_partitions || []),
        //   ...(compareItem.cutting_partitions || [])
        // ];

        // Remove merged item
        result.splice(j, 1);
        j--;
      }
    }
  }

  return result;
}